import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
//  珠海非遗定制弹窗  数据对接非遗项目
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr } from "@/utils/utils";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  data() {
    return {
      zhfyPass: 'zhfyxm',
      redirectform: '57ed207dcf924429c45100c202c62142651c83312c7ae7d68a7aa7777892039a5066948fb3dc970fc240392e22722d5c',
      formUserItem: {},
      rightTopflag: false
    };
  },
  watch: {
    '$attrs.detail'(val) {
      if (val) {
        let cxy = val.mapCoordinates.split(',');
        console.log(cxy);
        this.rightTopflag = Number(cxy[0]) > 0.001504 && Number(cxy[1]) > 0.002696 || Number(cxy[0]) > 0.001504 ? true : false;
        this.getDetail(val.placeName);
      }
    }
  },
  methods: {
    getDetail(name) {
      this.formUserItem = {};
      let _this = this;
      let form = {
        deptId: this.$route.query.fid,
        formId: 'cultural_heritage_project',
        searchStr: {
          'model': 0,
          'filters': [[{
            'alias': 'title',
            'compt': 'editinput',
            'express': 'like',
            'val': name
          }]]
        },
        t: this.redirectform,
        page: 1,
        limit: 1
      };
      form.searchStr = encodeURI(JSON.stringify(form.searchStr));
      this.$api.singleadvanceSearchv2(form).then(res => {
        if (res.totalRow > 0) {
          let dataList = res.dataList.map(item => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            let image = handleHttp(itemformat.thumb[0].fileUrl);
            item.itemformdata.image = image.replace();
            // 封装门户地址
            item.itemformdata.gateway = `https://all.chaoxing.com/cultural_heritage_resources/web/views/readwxmap.html?pageId=693778&wfwfid=216022&websiteId=401727&id=${itemformat.number}&mapid=${this.$route.query.id}`;
            return item;
          });
          this.formUserItem = dataList[0].itemformdata;
        }
      });
    },
    // 获取地区
    getAddress(val) {
      let pac = val ? val.split('|')[1] : '';
      return pac ? pac.split(',')[2] : '';
    }
  }
};